import BaseHeader from './Header'

export default BaseHeader
